import React from "react";
import "./css/PageWrapper.css";

const PageWrapper = ({ children, style }) => {
  return (
    <div className="page-wrapper" style={style}>
      {children}
    </div>
  );
};

export default PageWrapper;
